module.exports = __webpack_public_path__ + "img/background-image.46626e25.png";